import React, { useEffect, useState } from 'react';
// @material-ui/core components
import { makeStyles } from '@material-ui/core/styles';

import Card from 'components/Card/Card.js';
import CardBody from 'components/Card/CardBody.js';
import CardIcon from 'components/Card/CardIcon.js';
import CardHeader from 'components/Card/CardHeader.js';
import { Assignment, Done } from '@material-ui/icons';
import { cardTitle } from 'assets/jss/material-dashboard-pro-react.js';
import ReactTable from 'components/ReactTable/ReactTable.js';
import Button from 'components/CustomButtons/Button.js';

import { WithApp } from 'contexts/appContext';
import ModalFull from 'components/Tvendo/Common/ModalFull';
import { wsFindBy, wsGetAll } from 'services/WService';
import { Autocomplete } from '@material-ui/lab';
import GridContainer from 'components/Grid/GridContainer';
import GridItem from 'components/Grid/GridItem';
import { TextField } from '@material-ui/core';

const useStyles = makeStyles({
  cardIconTitle: {
    ...cardTitle,
    marginTop: '15px',
    marginBottom: '0px'
  }
});

const columns = [
  { Header: '#', accessor: 'num', excelEnabled: false, width: 120 },
  { Header: 'Concepto', accessor: 'pymt_concept_description' },
  { Header: 'Centro costo', accessor: 'pymt_expense_center_description' },
  { Header: 'Zona', accessor: 'base_zone_description' },
  /* { Header: 'Estado', accessor: 'state' }, */
  { Header: '', accessor: 'actions', excelEnabled: false, width: 0 }
];

export default WithApp(function ConceptModal(props) {
  const classes = useStyles();
  const { open, setOpen, setConcept, isUpdate, saveRow, purchase } = props;

  const [valueSearch, setValueSearch] = useState({});

  const handleChange = (field, value) => {
    setValueSearch({
      ...valueSearch,
      [field]: value
    });
  };

  function getFildsValueSelect(field, value = null) {
    if (value != null) {
      delete valueSearch[field];
      listAccountConcepts({ [field]: value.id, ...valueSearch });
      handleChange(field, value.id);
    } else {
      delete valueSearch[field];
      listAccountConcepts(valueSearch);
      handleChange(field, null);
    }
  }

  //#region listados
  const [zones, setZones] = useState([]);
  const [concepts, setConcepts] = useState([]);
  const [costCenter, setCostCenter] = useState([]);
  const [accountConcepts, setAccountConcepts] = useState([]);

  async function listZones() {
    let response = await wsGetAll('base/zone');
    if (response.success) setZones(response.data);
  }

  async function listConcepts() {
    let response = await wsGetAll('pymt/concept');
    if (response.success) setConcepts(response.data);
  }

  async function listCostCenter() {
    let response = await wsGetAll('pymt/expense-center');
    if (response.success) setCostCenter(response.data);
  }

  async function listAccountConcepts(valueSearch) {
    for (var clave in valueSearch) {
      if (valueSearch[clave] == null || valueSearch[clave] == '') {
        delete valueSearch[clave]; //eliminamos las claves sin data
      }
    }

    let response = await wsFindBy('pymt/account-concept', valueSearch);
    if (response.success) setAccountConcepts(response.data);
  }

  //#endregion

  useEffect(() => {
    if (open) {
      listZones();
      listConcepts();
      listCostCenter();
      listAccountConcepts();
    }
  }, [open]);

  return (
    <ModalFull title="Conceptos" open={open} setOpen={setOpen}>
      <Card>
        <CardHeader icon>
          <CardIcon color={props.themeContext.buttonColor}>
            <Assignment />
          </CardIcon>
          <h4 className={classes.cardIconTitle}>Elija un concepto</h4>
        </CardHeader>
        <CardBody>
          <GridContainer>
            <GridItem xs={12} md={3}>
              {zones.length > 0 ? (
                <Autocomplete
                  options={zones}
                  getOptionLabel={(option) => option.description}
                  defaultValue={zones.find((item) => item.id == purchase.base_zone_id) || undefined}
                  renderInput={(params) => <TextField {...params} label="Zona" margin="normal" />}
                  onChange={(e, item) => {
                    getFildsValueSelect('base_zone_id', item);
                  }}
                />
              ) : undefined}
            </GridItem>
            <GridItem xs={12} md={3}>
              <Autocomplete
                options={concepts}
                getOptionLabel={(option) => option.description}
                defaultValue={undefined}
                renderInput={(params) => (
                  <TextField {...params} label="Concepto gastos" margin="normal" />
                )}
                onChange={(e, item) => {
                  getFildsValueSelect('pymt_concept_id', item);
                }}
              />
            </GridItem>
            <GridItem xs={12} md={3}>
              <Autocomplete
                options={costCenter}
                getOptionLabel={(option) => option.description}
                defaultValue={undefined}
                renderInput={(params) => (
                  <TextField {...params} label="Centro de costo" margin="normal" />
                )}
                onChange={(e, item) => {
                  getFildsValueSelect('pymt_expense_center_id', item);
                }}
              />
            </GridItem>
          </GridContainer>
          <ReactTable
            defaultWidth={1100}
            exportExcel={false}
            columns={columns}
            data={accountConcepts.map((item, i) => {
              return {
                num: (
                  <div className="actions-right">
                    <Button
                      justIcon
                      size="sm"
                      round
                      onClick={() => {
                        if (isUpdate.open) {
                          saveRow(isUpdate.id, { pymt_account_concept_id: item.id });
                        } else {
                          setConcept(item);
                        }
                        setOpen(false);
                      }}
                      color={props.themeContext.buttonColorSuccess}
                    >
                      <Done />
                    </Button>
                  </div>
                ),
                pymt_concept_description: item.pymt_concept_description,
                pymt_expense_center_description: item.pymt_expense_center_description,
                base_zone_description: item.base_zone_description,
                /* state: item.state === 'N' ? 'Activo' : 'Inactivo', */
                actions: ''
              };
            })}
          />
        </CardBody>
      </Card>
    </ModalFull>
  );
});
